import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleTwoToneSvg from "@ant-design/icons-svg/es/asn/EyeInvisibleTwoTone";
import AntdIcon from '../components/AntdIcon';
var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: EyeInvisibleTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(EyeInvisibleTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'EyeInvisibleTwoTone';
}
export default RefIcon;